/// <reference types="@shopify/polaris-types" />
import { useState } from "react";
import {
  AUTOCOMPLETE_PACKAGES,
  type AutocompleteBalanceResponse,
} from "@codway-dev/shared";

type Purchase = AutocompleteBalanceResponse["recent_purchases"][number];

const PACK_NAME = Object.fromEntries(
  AUTOCOMPLETE_PACKAGES.map((p) => [p.id, p.name])
);

const PURCHASE_STATUS_LABEL: Record<Purchase["status"], string> = {
  PENDING: "Procesando…",
  CONFIRMED: "Confirmado",
  DECLINED: "Rechazado",
  EXPIRED: "Expirado",
};

const PURCHASE_STATUS_TONE: Record<
  Purchase["status"],
  "info" | "success" | "critical" | "warning"
> = {
  PENDING: "info",
  CONFIRMED: "success",
  DECLINED: "critical",
  EXPIRED: "warning",
};

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("es", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function PurchaseHistory({ purchases }: { purchases: Purchase[] }) {
  const [open, setOpen] = useState(false);

  if (purchases.length === 0) return null;

  return (
    <s-section>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "4px 0",
          background: "none",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <strong style={{ fontSize: "14px" }}>Historial de compras</strong>
        <span style={{ fontSize: "12px", color: "#6d7175" }}>
          {open ? "▲" : "▼"}
        </span>
      </button>

      {open && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {purchases.map((p, i) => (
            <div
              key={p.id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 0",
                borderTop: i > 0 ? "1px solid #f1f2f3" : "none",
                gap: "12px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#202223",
                    marginBottom: "2px",
                  }}
                >
                  {PACK_NAME[p.package_id] ?? p.package_id}
                </div>
                <div style={{ fontSize: "12px", color: "#8c9196" }}>
                  {formatDate(p.created_at)}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  flexShrink: 0,
                }}
              >
                <span style={{ fontSize: "13px", color: "#6d7175" }}>
                  {p.credits_granted.toLocaleString("es")} créditos
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#202223",
                    minWidth: "48px",
                    textAlign: "right",
                  }}
                >
                  ${p.price_usd.toFixed(2)}
                </span>
                <s-badge tone={PURCHASE_STATUS_TONE[p.status]}>
                  {PURCHASE_STATUS_LABEL[p.status]}
                </s-badge>
              </div>
            </div>
          ))}
        </div>
      )}
    </s-section>
  );
}
